import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=6039d02a&scoped=true"
import script from "./SideMenu.vue?vue&type=script&lang=js"
export * from "./SideMenu.vue?vue&type=script&lang=js"
import style0 from "./SideMenu.vue?vue&type=style&index=0&id=6039d02a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6039d02a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ObjectsItem: require('/app/components/ObjectsItem.vue').default})
